import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import classes from './PageBase.styles.less';
export default function PageBase({ children }) {
    const [theme] = useTheme();
    return (_jsx("main", { className: cx(classes.wrapper, classes[theme]), children: _jsxs("div", { className: classes.container, children: [_jsx(Header, {}), children, _jsx(Footer, {})] }) }));
}
